import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import { ReadContractor, WriteContractor } from "@/types/contractor";

export const ContractorsService = new APIService<
  ReadContractor,
  WriteContractor
>(API.Contractors);

export const fetchContractorsList = ContractorsService.getList;
export const fetchContractor = ContractorsService.get;
export const postContractor = ContractorsService.post;
export const patchContractor = ContractorsService.patch;
export const deleteContractor = ContractorsService.delete;

export const activateContractor = (id: string) =>
  ContractorsService.patch(id, {}, "activate");

export const deactivateContractor = (id: string) =>
  ContractorsService.patch(id, {}, "deactivate");

export const resetContractorPassword = (id: string) =>
  ContractorsService.post({}, `${id}/reset-password`);
